import Swiper from "swiper";

function centeredSlider() {
  return {
    swiper: null,

    init() {
      this.$nextTick(() => {
        this.initSlider();
      });
    },

    initSlider() {
      if (!this.$refs.slider) {
        console.error("❌ Slider ref not found!");
        return;
      }
      if (this.swiper) return;

      // Count slides before Swiper init
      const slides = this.$refs.slider.querySelectorAll(".swiper-slide");

      // Remove slides that contain paragraph content
      slides.forEach((slide, index) => {
        const hasParagraph =
          slide.textContent.includes("paragraph") ||
          slide.innerHTML.includes("<p>");

        if (hasParagraph) {
          slide.remove();
        }
      });

      this.swiper = new Swiper(this.$refs.slider, {
        loop: true,
        slidesPerView: 2,
        centeredSlides: true,
        observer: true,
        observeParents: true,
      });
    },
  };
}

export default centeredSlider;
